"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FireAlarmApp = _interopRequireDefault(require("FireAlarmUi/js/FireAlarmApp"));

var _default = _react.default.createClass({
  displayName: "FireAlarm",
  componentDidMount: function componentDidMount() {
    var config = {
      appName: 'MeetingsPublic',
      containers: {
        default: {
          parent: document.getElementById('meetings-public-fire-alarm-container')
        }
      }
    };
    var fireAlarm = new _FireAlarmApp.default(window.hubspot, config);
    window.hubspot[_FireAlarmApp.default.HUBSPOT_FIREALARM_KEY] = fireAlarm;
    fireAlarm.start();
  },
  render: function render() {
    return _react.default.createElement("div", {
      id: "meetings-public-fire-alarm-container"
    });
  }
});

exports.default = _default;
module.exports = exports.default;